import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RouterService } from '../../router-service';
import { IServiceFactory } from '../../service-factory';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
  export class NotLoggedInGuard implements CanActivate {

    routerService: RouterService;
    constructor(
        private serviceFactory: IServiceFactory, 
        private router: Router
        ) {
        this.routerService = this.serviceFactory.getRouterService();
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    {
        var url = this.router.parseUrl(state.url);
        return this.routerService.IsLoggedIn().pipe(
            map( model => {
                if(model.LoggedIn){
                    return true;
                }
                else{
                    //var url2 = next.url;
                    //var url = this.router.parseUrl(state.url); // grab the url they are trying to go to
                    //var returnUrl = this.router.parseUrl('/ELearning/Login'); // 
                    var returnUrl = this.router.parseUrl(model.LoginURL); // grab the login url
                    returnUrl.queryParams['ReturnUrl'] = url; // add the url they originally went to to the query params of the return url

                    window.location.href = returnUrl.toString();
                    return true;
                }
            }),
            catchError((err) => {
                return of(false);
            })
    
        );

    }
  }